import React from 'react';
import PropTypes from 'prop-types';
import { StyledVendorTypeIcon } from './StyledVendorTypeIcon';
import {WireIcon, WithLessCreditCardIcon} from '../../../../icons';


const VendorTypeIcon = ({
  vendor,
  ...rest
}) => {
  const hasBeneficiary = Boolean(vendor?.beneficiary_id);

  return (
    <StyledVendorTypeIcon
      size='small'
      {...rest}
    >
      <WithLessCreditCardIcon />
      {hasBeneficiary && <WireIcon />}
    </StyledVendorTypeIcon>
  );
}

VendorTypeIcon.propTypes = {
  vendor: PropTypes.shape({
    beneficiary_id: PropTypes.any
  }),
}

export default VendorTypeIcon;
